// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"64ae4bbb","383":"a6119e1c","453":"dd728d99","478":"4077dbd2"}[chunkId] + ".chunk.js";
};